// extracted by mini-css-extract-plugin
export var actionButton = "_s6-0";
export var actionMenuContainer = "_s6-i";
export var bubble = "_s6-2";
export var bubbleActionMenu = "_s6-j";
export var bubbleContext = "_s6-6";
export var bubbleItems = "_s6-7";
export var customer = "_s6-3";
export var divider = "_s6-8";
export var fileList = "_s6-9";
export var hiddenComment = "_s6-o";
export var infoAbove = "_s6-a";
export var internal = "_s6-4";
export var lightActionButton = "_s6-1";
export var link = "_s6-b";
export var merchant = "_s6-5";
export var message = "_s6-c";
export var profilePicture = "_s6-e";
export var quillToolbarContainer = "_s6-f";
export var senderDate = "_s6-g";
export var senderDateCustomer = "_s6-h";
export var senderName = "_s6-d";
export var time = "_s6-k";
export var uploadedImage = "_s6-l";
export var username = "_s6-m";
export var xsmall = "_s6-n";